module.exports = __webpack_public_path__ + "img/Billing.1e85a7fd.svg";